"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = useColumns;
var react_1 = require("react");
var constants_1 = require("../constants");
function useColumns() {
    var columns = (0, react_1.useMemo)(function () { return constants_1.userColumns; }, []);
    var headerColumns = (0, react_1.useMemo)(function () { return constants_1.userColumns.filter(function (column) { return constants_1.INITIAL_VISIBLE_COLUMNS.includes(column.uid); }).map(function (column) { return (__assign(__assign({}, column), { id: column.uid })); }); }, []);
    var visibleColumns = (0, react_1.useMemo)(function () { return new Set(constants_1.INITIAL_VISIBLE_COLUMNS); }, []);
    var excludeSortColumns = (0, react_1.useMemo)(function () { return columns.filter(function (_a) {
        var sortable = _a.sortable;
        return sortable !== true;
    }); }, [columns]);
    var onVisibleColumnsChanged = function () { };
    var setTableColumnConfig = function () { };
    var tableColumnConfig = (0, react_1.useMemo)(function () { return ({}); }, []);
    return { columns: columns, excludeSortColumns: excludeSortColumns, headerColumns: headerColumns, onVisibleColumnsChanged: onVisibleColumnsChanged, setTableColumnConfig: setTableColumnConfig, tableColumnConfig: tableColumnConfig, visibleColumns: visibleColumns };
}
